import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DialogClienteAcordoMaterial from "./components/DialogClienteAcordoMaterial";
import DialogClienteAcordoMaterialAlternativo from "./components/DialogClienteAcordoMaterialAlternativo";
import DialogClienteAcordoMaterialAlternativosLista from "./components/DialogClienteAcordoMaterialAlternativosLista";
import DialogValorReceberFabricante from "./components/DialogValorReceberFabricante";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";

import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import ListIcon from "@mui/icons-material/List";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const clienteLabel = (c) => (c?.nome ? `${c.nome} (${c.ref})` : "");

const fabricanteLabel = (f) => (f?.nome ? `${f.nome} (${f.ref})` : "");

const materialLabel = (m) => (m?.nome ? `${m.nome} (${m.ref})` : "");

export default function ClientesAcordosMateriais() {
  const { showAlert } = useAlert();
  const { temPermissao, userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [clientesCombo, setClientesCombo] = useState([]);
  const [fabricantesCombo, setFabricantesCombo] = useState([]);
  const [materiaisCombo, setMateriaisCombo] = useState([]);
  const [fabricantesAcordosCombo, setFabricantesAcordosCombo] = useState([]);

  const [clienteInput, setClienteInput] = useState("");
  const [fabricanteInput, setFabricanteInput] = useState("");

  const [alternativaInput, setAlternativaInput] = useState("");
  const [openDialogAlternativos, setOpenDialogAlternativos] = useState(false);
  const [openDialogFormAlternativo, setOpenDialogFormAlternativo] = useState(false);
  const [acordoAlternativosSelecionado, setAcordoAlternativosSelecionado] = useState(null);
  const [alternativosAcordo, setAlternativosAcordo] = useState([]);

  const [formAlternativo, setFormAlternativo] = useState({
    id: null,
    idclienteacordomaterial: null,
    refmaterial: "",
    inativo: 0,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [editando, setEditando] = useState(false);

  const [openDialogValorReceber, setOpenDialogValorReceber] = useState(false);
  const [acordoValorReceber, setAcordoValorReceber] = useState(null);
  const [valorReceberData, setValorReceberData] = useState([]);
  const [loadingExcelValorReceber, setLoadingExcelValorReceber] = useState(false);
  const [valorFabricanteInput, setValorFabricanteInput] = useState("");
  const [valorReceberForm, setValorReceberForm] = useState({
    idclienteacordomaterial: null,
    reffabricante: "",
    datainicial: "",
    datafinal: "",
  });

  const [form, setForm] = useState({
    id: null,
    refcliente: "",
    reffabricante: "",
    tipodesconto: "PERCENTAGEM",
    valor: "",
    suporte_jf_perc: 100,
    suporte_fabricante_perc: 0,
    datainicial: "",
    datafinal: "",
    utilizacao_unica: 0,
    obs: "",
    inativo: 0,
  });

  const carregar = async () => {
    setLoading(true);
    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelClientesAcordosMateriais", {})
    );
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setData(Array.isArray(payload) ? payload : []);
  };

  const carregarClientesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelClientesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setClientesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesAcordosCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelFabricantesAcordosMateriaisCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesAcordosCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelMateriaisCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setMateriaisCombo(Array.isArray(payload) ? payload : []);
  };

  useEffect(() => {
    carregar();
    carregarClientesCombo();
    carregarFabricantesCombo();
    carregarMateriaisCombo();
  }, []);

  const limparForm = () => {
    setForm({
      id: null,
      refcliente: "",
      reffabricante: "",
      tipodesconto: "PERCENTAGEM",
      valor: "",
      suporte_jf_perc: 100,
      suporte_fabricante_perc: 0,
      datainicial: "",
      datafinal: "",
      utilizacao_unica: 0,
      obs: "",
      inativo: 0,
    });

    setClienteInput("");
    setFabricanteInput("");
  };

  const abrirNovo = () => {
    setEditando(false);
    limparForm();
    setOpenDialog(true);
  };

  const abrirEditar = async (row) => {
    setEditando(true);

    setForm({
      id: row.id,
      refcliente: row.refcliente || "",
      reffabricante: row.reffabricante || "",
      tipodesconto: row.tipodesconto || "PERCENTAGEM",
      valor: row.valor ?? "",
      suporte_jf_perc: row.suporte_jf_perc ?? 100,
      suporte_fabricante_perc: row.suporte_fabricante_perc ?? 0,
      datainicial: row.datainicial ? String(row.datainicial).substring(0, 10) : "",
      datafinal: row.datafinal ? String(row.datafinal).substring(0, 10) : "",
      utilizacao_unica: Number(row.utilizacao_unica || 0),
      obs: row.obs || "",
      inativo: Number(row.inativo || 0),
    });

    setClienteInput(row.cliente ? `${row.cliente} (${row.refcliente})` : "");
    setFabricanteInput(row.fabricante ? `${row.fabricante} (${row.reffabricante})` : "");

    setAcordoAlternativosSelecionado(row);
    await carregarAlternativosAcordo(row.id);
    limparFormAlternativo();

    setOpenDialog(true);
  };

  const guardar = async () => {
    if (!form.refcliente || !form.reffabricante) {
      showAlert("Preenche cliente e fabricante.", "warning");
      return;
    }

    if (Number(form.valor || 0) <= 0) {
      showAlert(
        form.tipodesconto === "PERCENTAGEM"
          ? "Indica a percentagem de desconto."
          : "Indica o valor em euros.",
        "warning"
      );
      return;
    }

    const totalSuporte =
      Number(form.suporte_jf_perc || 0) + Number(form.suporte_fabricante_perc || 0);

    if (Math.round(totalSuporte * 1000000) / 1000000 !== 100) {
      showAlert("A soma do suporte JF e fabricante tem de ser 100%.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      ...form,
      valor: Number(form.valor || 0),
      suporte_jf_perc: Number(form.suporte_jf_perc || 0),
      suporte_fabricante_perc: Number(form.suporte_fabricante_perc || 0),
      datainicial: form.datainicial || null,
      datafinal: form.datafinal || null,
      utilizacao_unica: Number(form.utilizacao_unica || 0),
      inativo: Number(form.inativo || 0),
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = editando
      ? "ClientesAcordosMateriais/UpdClienteAcordoMaterial"
      : "ClientesAcordosMateriais/InsClienteAcordoMaterial";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    console.log("payload", _);
    console.log("meta", meta);

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Desconto adicional gravado.", meta?.severity || "success");

    await carregar();

    if (!editando) {
      const novoId = meta?.data?.id;

      if (novoId) {
        const novoAcordo = {
          ...form,
          id: novoId,
        };

        setForm((p) => ({
          ...p,
          id: novoId,
        }));

        setEditando(true);
        setAcordoAlternativosSelecionado(novoAcordo);
        setAlternativosAcordo([]);

        setFormAlternativo({
          id: null,
          idclienteacordomaterial: novoId,
          refmaterial: "",
          inativo: 0,
        });

        setAlternativaInput("");
        setOpenDialogFormAlternativo(true);

        return;
      }
    }

    setOpenDialog(false);
  };

  const abrirValorReceber = () => {
    setAcordoValorReceber(null);
    setValorReceberData([]);
    setValorFabricanteInput("");

    setValorReceberForm({
      idclienteacordomaterial: null,
      reffabricante: "",
      datainicial: "",
      datafinal: "",
    });

    carregarFabricantesAcordosCombo();
    setOpenDialogValorReceber(true);
  };

  const abrirValorReceberAcordo = async (acordo, periodoExterno = null) => {
    if (!acordo?.id || !acordo?.reffabricante) return;

    const periodoInicial = {
      idclienteacordomaterial: acordo.id,
      reffabricante: acordo.reffabricante,
      datainicial:
        periodoExterno?.datainicial ||
        (acordo.datainicial ? String(acordo.datainicial).substring(0, 10) : ""),
      datafinal:
        periodoExterno?.datafinal ||
        (acordo.datafinal ? String(acordo.datafinal).substring(0, 10) : ""),
    };

    setAcordoValorReceber(acordo);
    setValorReceberData([]);
    setValorReceberForm(periodoInicial);

    setValorFabricanteInput(
      acordo.fabricante ? `${acordo.fabricante} (${acordo.reffabricante})` : acordo.reffabricante
    );

    setOpenDialogValorReceber(true);
    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelValorReceberFabricante", periodoInicial)
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setValorReceberData(Array.isArray(payload) ? payload : []);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const idacordo = Number(params.get("ccAcordo") || 0);
    const datainicial = params.get("datainicial") || "";
    const datafinal = params.get("datafinal") || "";

    if (!idacordo || !Array.isArray(data) || data.length === 0) {
      return;
    }

    const acordo = data.find((linha) => Number(linha?.id || 0) === idacordo);

    window.history.replaceState({}, document.title, window.location.pathname);

    if (!acordo) {
      showAlert("Acordo não encontrado.", "warning");
      return;
    }

    abrirValorReceberAcordo(acordo, {
      datainicial,
      datafinal,
    });

    // A lista é carregada depois da entrada na página.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const consultarValorReceber = async () => {
    if (!valorReceberForm.reffabricante) {
      showAlert("Seleciona o fabricante.", "warning");
      return;
    }

    if (!valorReceberForm.datainicial || !valorReceberForm.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelValorReceberFabricante", valorReceberForm)
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setValorReceberData(Array.isArray(payload) ? payload : []);
  };

  const totalValorReceberFabricante = valorReceberData.reduce(
    (acc, row) => acc + Number(row.valor_receber_fabricante || 0),
    0
  );

  const formatarQuantidade = (valor) =>
    Number(valor || 0).toLocaleString("pt-PT", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });

  const formatarMoeda = (valor) =>
    Number(valor || 0).toLocaleString("pt-PT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatarPercentagem = (valor) =>
    Number(valor || 0).toLocaleString("pt-PT", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });

  const exportarValorReceberExcel = async () => {
    if (!valorReceberForm.reffabricante) {
      showAlert("Seleciona o fabricante.", "warning");
      return;
    }

    if (!valorReceberForm.datainicial || !valorReceberForm.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    try {
      setLoadingExcelValorReceber(true);

      const res = await api({
        url: "ClientesAcordosMateriais/ExportarValorReceberFabricante",
        method: "post",
        data: valorReceberForm,
        responseType: "arraybuffer",
      });

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = `AcordosPrecos_${new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/[-:T]/g, "")
        .replace(/^(\d{6})(\d{4})$/, "$1_$2")}.xlsx`;

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Excel gerado com sucesso.", "success");
    } catch (err) {
      showAlert("Erro ao gerar Excel.", "error");
    } finally {
      setLoadingExcelValorReceber(false);
    }
  };

  const limparFormAlternativo = () => {
    setAlternativaInput("");

    setFormAlternativo({
      id: null,
      idclienteacordomaterial: acordoAlternativosSelecionado?.id || form.id || null,
      refmaterial: "",
      inativo: 0,
    });
  };

  const carregarAlternativosAcordo = async (idclienteacordomaterial) => {
    if (!idclienteacordomaterial) return;

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelClienteAcordoMaterialRefs", {
        idclienteacordomaterial,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativosAcordo(Array.isArray(payload) ? payload : []);
  };

  const abrirAlternativos = async (acordo) => {
    setAcordoAlternativosSelecionado(acordo);
    setAlternativosAcordo([]);
    setOpenDialogAlternativos(true);

    setFormAlternativo({
      id: null,
      idclienteacordomaterial: acordo.id,
      refmaterial: "",
      inativo: 0,
    });

    setAlternativaInput("");

    await carregarAlternativosAcordo(acordo.id);
  };

  const abrirEditarPrincipal = (acordo) => {
    setOpenDialogAlternativos(false);
    abrirEditar(acordo);
  };

  const abrirNovoAlternativo = () => {
    limparFormAlternativo();

    setFormAlternativo((p) => ({
      ...p,
      idclienteacordomaterial: acordoAlternativosSelecionado?.id || null,
    }));

    setOpenDialogFormAlternativo(true);
  };

  const editarAlternativo = (alt) => {
    setFormAlternativo({
      id: alt.id,
      idclienteacordomaterial: alt.idclienteacordomaterial,
      refmaterial: alt.refmaterial || "",
      inativo: Number(alt.inativo || 0),
    });

    setAlternativaInput(
      alt.material ? `${alt.material} (${alt.refmaterial})` : alt.refmaterial || ""
    );

    setOpenDialogFormAlternativo(true);
  };

  const guardarAlternativo = async () => {
    if (!formAlternativo.idclienteacordomaterial) {
      showAlert("Acordo principal inválido.", "error");
      return;
    }

    let refMaterialSelecionado = formAlternativo.refmaterial;

    if (!refMaterialSelecionado && alternativaInput) {
      const match = alternativaInput.match(/\(([^)]+)\)\s*$/);
      refMaterialSelecionado = match?.[1] || "";
    }

    if (!refMaterialSelecionado) {
      showAlert("Indica o material.", "warning");
      return;
    }

    const body = {
      id: formAlternativo.id,
      idclienteacordomaterial: formAlternativo.idclienteacordomaterial,
      refmaterial: refMaterialSelecionado,
      inativo: Number(formAlternativo.inativo || 0),
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = formAlternativo.id
      ? "ClientesAcordosMateriais/UpdClienteAcordoMaterialRef"
      : "ClientesAcordosMateriais/InsClienteAcordoMaterialRef";

    setLoading(true);
    const [_, err, meta] = await handleApi(api.post(endpoint, body));
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material gravado.", meta?.severity || "success");

    await carregarAlternativosAcordo(formAlternativo.idclienteacordomaterial);
    await carregar();

    setOpenDialogFormAlternativo(false);
    limparFormAlternativo();
  };

  const valorReceberColumns = useMemo(
    () => [
      {
        Header: "Cliente",
        accessor: "cliente",
        width: 260,
        minWidth: 180,
      },
      {
        Header: "Ref. Cliente",
        accessor: "refcliente",
        width: 120,
        minWidth: 110,
      },
      {
        Header: "Material",
        accessor: "material",
        width: 300,
        minWidth: 200,
      },
      {
        Header: "Ref. Material",
        accessor: "refmaterial",
        width: 120,
        minWidth: 110,
      },
      {
        Header: "Data",
        accessor: "faturadata",
        width: 110,
        minWidth: 110,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Fatura",
        accessor: "faturanumero",
        width: 130,
        minWidth: 120,
      },
      {
        Header: "Estornada",
        accessor: "estornada",
        width: 100,
        minWidth: 100,
        align: "center",
      },
      {
        Header: "Fatura estornada",
        accessor: "faturaestornada",
        width: 140,
        minWidth: 130,
      },
      {
        Header: "Qtd",
        accessor: "qtd",
        width: 110,
        minWidth: 100,
        align: "right",
        Cell: ({ row }) =>
          `${formatarQuantidade(row.original.qtd)} ${row.original.qtdunid || ""}`.trim(),
      },
      {
        Header: "Preço Acons.",
        accessor: "precoaconselhado",
        width: 120,
        minWidth: 110,
        align: "right",
        Cell: ({ value }) => formatarMoeda(value),
      },
      {
        Header: "Tipo",
        accessor: "tipodesconto",
        width: 130,
        minWidth: 120,
      },
      {
        Header: "Valor",
        accessor: "valor",
        width: 110,
        minWidth: 100,
        align: "right",
        Cell: ({ row }) =>
          row.original.tipodesconto === "PERCENTAGEM"
            ? `${formatarPercentagem(row.original.valor)}%`
            : `${formatarMoeda(row.original.valor)} €`,
      },
      {
        Header: "Suporte JF",
        accessor: "suporte_jf_perc",
        width: 110,
        minWidth: 100,
        align: "right",
        Cell: ({ value }) => `${formatarPercentagem(value)}%`,
      },
      {
        Header: "Suporte Fabr.",
        accessor: "suporte_fabricante_perc",
        width: 120,
        minWidth: 110,
        align: "right",
        Cell: ({ value }) => `${formatarPercentagem(value)}%`,
      },
      {
        Header: "Valor Receber",
        accessor: "valor_receber_fabricante",
        width: 140,
        minWidth: 130,
        align: "right",
        Cell: ({ value }) => (
          <MDTypography variant="caption" fontWeight="bold">
            {formatarMoeda(value)} €
          </MDTypography>
        ),
      },
    ],
    []
  );

  const columns = useMemo(
    () => [
      {
        Header: "",
        id: "acoes",
        disableFilters: true,
        width: 138,
        minWidth: 138,
        maxWidth: 138,
        disableSortBy: true,
        filterable: false,
        sortable: false,
        hideable: false,
        resizable: false,
        Cell: ({ row }) => {
          const a = row.original;

          return (
            <div style={{ display: "flex", gap: 4, whiteSpace: "nowrap" }}>
              <IconButton
                size="small"
                color="primary"
                disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "u")}
                onClick={() => abrirEditar(a)}
                title="Editar desconto"
              >
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="info"
                disabled={
                  !temPermissao("Menu Acordos Cliente/Fabricante", "u") ||
                  Number(a.totalmateriais || 0) === 0
                }
                onClick={() => abrirAlternativos(a)}
                title={Number(a.totalmateriais || 0) === 0 ? "Sem materiais" : "Resumo do acordo"}
              >
                <InfoIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="success"
                disabled={
                  !temPermissao("Menu Acordos Cliente/Fabricante", "r") ||
                  Number(a.totalmateriais || 0) === 0
                }
                onClick={() => abrirValorReceberAcordo(a)}
                title={
                  Number(a.totalmateriais || 0) === 0 ? "Sem materiais" : "Ver valor a receber"
                }
              >
                <ListIcon fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
      { Header: "Cliente", accessor: "cliente" },
      { Header: "Ref. Cliente", accessor: "refcliente" },
      { Header: "Fabricante", accessor: "fabricante" },

      { Header: "Tipo", accessor: "tipodesconto" },
      {
        Header: "Valor",
        accessor: "valor",
        align: "right",
        disableFilters: true,
        Cell: ({ row }) =>
          row.original.tipodesconto === "PERCENTAGEM"
            ? `${formatarPercentagem(row.original.valor)}%`
            : `${formatarMoeda(row.original.valor)} €`,
      },
      {
        Header: "Suporte JF",
        accessor: "suporte_jf_perc",
        align: "right",
        Cell: ({ value }) => `${formatarPercentagem(value)}%`,
      },
      {
        Header: "Suporte Fabr.",
        accessor: "suporte_fabricante_perc",
        align: "right",
        Cell: ({ value }) => `${formatarPercentagem(value)}%`,
      },
      {
        Header: "Data inicial",
        accessor: "datainicial",
        width: 110,
        minWidth: 110,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Data final",
        accessor: "datafinal",
        width: 110,
        minWidth: 110,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Única",
        accessor: "utilizacao_unica",
        align: "center",
        width: 90,
        minWidth: 90,
        filterType: "simNao",
        Cell: ({ value }) => (Number(value || 0) === 1 ? "Sim" : "Não"),
      },
      { Header: "Fatura consumida", accessor: "fatura_consumida" },
      {
        Header: "Ativo",
        accessor: "inativo",
        align: "center",
        width: 90,
        minWidth: 90,
        filterType: "simNaoInverso",
        Cell: ({ value }) => (Number(value || 0) === 1 ? "Não" : "Sim"),
      },
      { Header: "Refs. Materiais", accessor: "refs_materiais" },
      { Header: "Materiais", accessor: "materiais" },
    ],
    [temPermissao]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox pt={1}>
        <Card>
          <MDBox p={{ xs: 1.5, md: 3 }}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems={{ xs: "stretch", md: "center" }}
              flexDirection={{ xs: "column", md: "row" }}
              gap={1}
              mb={2}
              sx={{
                "& .MuiButton-root": {
                  width: { xs: "100%", md: "auto" },
                },
              }}
            >
              <MDTypography variant="h6">Descontos adicionais cliente/material</MDTypography>

              <MDBox
                display="flex"
                alignItems={{ xs: "stretch", sm: "center" }}
                flexDirection={{ xs: "column", sm: "row" }}
                gap={1}
              >
                <MDButton
                  color="info"
                  disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "r")}
                  onClick={abrirValorReceber}
                >
                  Valor a receber
                </MDButton>

                <MDButton
                  color="success"
                  disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "w")}
                  onClick={abrirNovo}
                >
                  Novo desconto
                </MDButton>
              </MDBox>
            </MDBox>

            <ProjectTable
              tableKey="clientes-acordos-materiais"
              version="v1"
              columns={columns}
              data={data}
              loading={loading}
              emptyMessage="Sem descontos adicionais cliente/material para apresentar."
              minWidth={1600}
              maxHeight="68vh"
              showKeepFilters
            />
          </MDBox>
        </Card>
      </MDBox>

      <DialogValorReceberFabricante
        open={openDialogValorReceber}
        onClose={() => setOpenDialogValorReceber(false)}
        PaperComponent={PaperComponent}
        acordo={acordoValorReceber}
        fabricantesAcordosCombo={fabricantesAcordosCombo}
        valorFabricanteInput={valorFabricanteInput}
        setValorFabricanteInput={setValorFabricanteInput}
        valorReceberForm={valorReceberForm}
        setValorReceberForm={setValorReceberForm}
        carregarFabricantesAcordosCombo={carregarFabricantesAcordosCombo}
        fabricanteLabel={fabricanteLabel}
        consultarValorReceber={consultarValorReceber}
        loadingExcelValorReceber={loadingExcelValorReceber}
        exportarValorReceberExcel={exportarValorReceberExcel}
        totalValorReceberFabricante={totalValorReceberFabricante}
        formatarMoeda={formatarMoeda}
        valorReceberColumns={valorReceberColumns}
        valorReceberData={valorReceberData}
        loading={loading}
      />

      <DialogClienteAcordoMaterial
        open={openDialog}
        onClose={() => {
          if (form.id && alternativosAcordo.length === 0) {
            showAlert("Adicione pelo menos um material ao acordo.", "warning");
            return;
          }

          setOpenDialog(false);
        }}
        PaperComponent={PaperComponent}
        editando={editando}
        form={form}
        setForm={setForm}
        clientesCombo={clientesCombo}
        fabricantesCombo={fabricantesCombo}
        clienteInput={clienteInput}
        setClienteInput={setClienteInput}
        fabricanteInput={fabricanteInput}
        setFabricanteInput={setFabricanteInput}
        clienteLabel={clienteLabel}
        fabricanteLabel={fabricanteLabel}
        carregarClientesCombo={carregarClientesCombo}
        carregarFabricantesCombo={carregarFabricantesCombo}
        guardar={guardar}
        abrirMateriais={() => {
          if (!form.id) {
            showAlert("Grave primeiro o acordo.", "warning");
            return;
          }

          setAcordoAlternativosSelecionado(form);
          carregarAlternativosAcordo(form.id);
          setOpenDialogAlternativos(true);
        }}
      />

      <DialogClienteAcordoMaterialAlternativo
        open={openDialogFormAlternativo}
        onClose={() => {
          if (form.id && alternativosAcordo.length === 0) {
            showAlert("Adicione pelo menos um material ao acordo.", "warning");
            return;
          }

          setOpenDialogFormAlternativo(false);
        }}
        PaperComponent={PaperComponent}
        formAlternativo={formAlternativo}
        setFormAlternativo={setFormAlternativo}
        alternativaInput={alternativaInput}
        setAlternativaInput={setAlternativaInput}
        materiaisCombo={materiaisCombo}
        materiaisJaAssociados={alternativosAcordo}
        materialLabel={materialLabel}
        carregarMateriaisCombo={carregarMateriaisCombo}
        guardarAlternativo={guardarAlternativo}
      />

      <DialogClienteAcordoMaterialAlternativosLista
        open={openDialogAlternativos}
        onClose={() => setOpenDialogAlternativos(false)}
        PaperComponent={PaperComponent}
        acordo={acordoAlternativosSelecionado}
        alternativos={alternativosAcordo}
        formatarValor={formatarMoeda}
        modoEdicao={openDialog}
        abrirNovoAlternativo={abrirNovoAlternativo}
        editarAlternativo={editarAlternativo}
      />
    </DashboardLayout>
  );
}
